import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrRefreshIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M12.7 11.7C12.8 11.8 12.9 12 12.9 12.2C12.9 12.4 12.8 12.6 12.7 12.7C12.6 12.8 11 14.4 8.2 14.4C6 14.4 4.4 13.2 3.4 12.2V13.2C3.4 13.4 3.3 13.6 3.2 13.7C3.1 13.8 2.9 13.9 2.7 13.9C2.5 13.9 2.3 13.8 2.2 13.7C2.1 13.6 2 13.4 2 13.2V10.2C2 10 2.1 9.8 2.2 9.7C2.3 9.6 2.5 9.5 2.7 9.5H5.7C5.9 9.5 6.1 9.6 6.2 9.7C6.3 9.8 6.4 10 6.4 10.2C6.4 10.4 6.3 10.6 6.2 10.7C6.1 10.8 5.9 10.9 5.7 10.9H4.1C4.9 11.8 6.3 13 8.2 13C10.4 13 11.7 11.7 11.7 11.7C11.8 11.6 12 11.5 12.2 11.5C12.4 11.5 12.6 11.6 12.7 11.7ZM14.2 2.7C14.1 2.6 13.9 2.5 13.7 2.5C13.5 2.5 13.3 2.6 13.2 2.7C13.1 2.8 13 3 13 3.2V4.2C12 3.2 10.4 2 8.2 2C5.4 2 3.8 3.6 3.7 3.7C3.6 3.8 3.5 4 3.5 4.2C3.5 4.4 3.6 4.6 3.7 4.7C3.8 4.8 4 4.9 4.2 4.9C4.4 4.9 4.6 4.8 4.7 4.7C4.7 4.7 6 3.4 8.2 3.4C10.1 3.4 11.5 4.6 12.3 5.5H10.7C10.5 5.5 10.3 5.6 10.2 5.7C10.1 5.8 10 6 10 6.2C10 6.4 10.1 6.6 10.2 6.7C10.3 6.8 10.5 6.9 10.7 6.9H13.7C13.9 6.9 14.1 6.8 14.2 6.7C14.3 6.6 14.4 6.4 14.4 6.2V3.2C14.4 3 14.3 2.8 14.2 2.7Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrRefreshIconComponent;
